appSocial
    .config(['$stateProvider', '$httpProvider', function ($stateProvider, $httpProvider) {

        const initResolver = ['SocialInitService', '$ionicLoading', '$timeout', '$state',
            /**
             * @param {SocialInitService} SocialInitService
             * @param $ionicLoading
             * @param $timeout
             * @param $state
             * @return {Promise<any>}
             */
            function (SocialInitService, $ionicLoading, $timeout, $state) {
                $ionicLoading.show({noBackdrop: true});
                return SocialInitService.init()
                    .then(() => $ionicLoading.hide())
                    .catch((error) => {
                        $ionicLoading.hide();
                        $timeout(() => $state.go('root.app.socialCrash'));
                        throw error;
                    })
            }];

        const traderResolver = [
            '$stateParams', '$ionicLoading', 'SocialAPIService', 'Trader', 'SocialFavoriteService', 'SocialPortfolioService',
            /**
             * @param $stateParams
             * @param $ionicLoading
             * @param {SocialAPIService} SocialAPIService
             * @param {Trader} Trader
             * @param {SocialFavoriteService} SocialFavoriteService
             * @return {Promise<Trader>}
             */
            function ($stateParams, $ionicLoading, SocialAPIService, Trader, SocialFavoriteService, SocialPortfolioService) {
                $ionicLoading.show({noBackdrop: true});
                return SocialAPIService.request.getPortfolio('/' + $stateParams.id)
                    .then((response) => {
                        $ionicLoading.hide();
                        const trader = new Trader(response.trader);
                        trader.isFavorite = SocialFavoriteService.isFavorite(trader.id);
                        SocialPortfolioService.initLeader(trader);
                        return trader;
                    })
            }]


        $stateProvider
            /**
             * Something went wrong page
             */
            .state('root.app.socialCrash', {
                url: '/social/error/:err',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/error/ErrorPage.html',
                        controller: 'errorPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                data: {
                    footer: true
                }
            })
            /**
             * Main feed
             */
            .state('root.app.social', {
                url: '/social/feed/:category/:nonce',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/leaders/LeadersPage.html',
                        controller: 'leadersPage',
                        controllerAs: '$ctrl',
                    }
                },
                // cache: false,
                resolve: {
                    init: initResolver
                },
                data: {
                    footer: true
                }
            })
            /**
             * Leader details
             */
            .state('root.app.socialLeader', {
                url: '/social/leader/:id',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/details/LeaderDetailsPage.html',
                        controller: 'leaderDetailsPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                resolve: {
                    trader: traderResolver
                },
                data: {
                    footer: false
                }
            })
            /**
             * Social signup page
             */
            .state('root.app.socialRegistration', {
                url: '/social/registration',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/registration/RegistrationPage.html',
                        controller: 'registrationPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                data: {
                    footer: false
                }
            })
            /**
             * Start/Stop copy
             */
            .state('root.app.socialCopy', {
                url: '/social/copy/:id/:action',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/leader-copy/LeaderCopyPage.html',
                        controller: 'leaderCopyPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                resolve: {
                    trader: traderResolver
                },
                data: {
                    footer: false
                }
            })
            /**
             * Add/Remove funds, set stop loss
             */
            .state('root.app.socialFunds', {
                url: '/social/funds/:id/:action',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/leader-funds/LeaderFundsPage.html',
                        controller: 'leaderFundsPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                resolve: {
                    trader: traderResolver
                },
                data: {
                    footer: false
                }
            })
            /**
             * Pause/Resume copy
             */
            .state('root.app.socialPause', {
                url: '/social/pause/:id/:action',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/leader-pause/LeaderPausePage.html',
                        controller: 'leaderPausePage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                resolve: {
                    trader: traderResolver
                },
                data: {
                    footer: false
                }
            })
            /**
             * My activity (potfolio)
             */
            .state('root.app.socialPortfolio', {
                url: '/social/portfolio/:category/:id',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/portfolio/PortfolioPage.html',
                        controller: 'portfolioPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                data: {
                    footer: false
                }
            })
            .state('root.app.socialCompare', {
                url: '/social/compare',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/leaders-compare/LeadersComparePage.html',
                        controller: 'leadersComparePage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                data: {
                    footer: false
                }
            })
            .state('root.app.socialGlossary', {
                url: '/social/glossary',
                views: {
                    'tab-social': {
                        templateUrl: 'pages/glossary/GlossaryPage.html',
                        controller: 'glossaryPage',
                        controllerAs: '$ctrl'
                    }
                },
                // cache: false,
                data: {
                    footer: false
                }
            })
        $httpProvider.interceptors.push('TokenInterceptor');
    }]);

